'use client';

import { motion } from 'framer-motion';
import Link from 'next/link';
import { InformativeTag } from './ui/custom/InformativeTag';

const HomeCTAClient3 = () => {
  return (
    <section className="bg-gradient-to-br from-amber-50 to-orange-100 relative overflow-hidden">
      <FloatingBackground />

      <div className="container-wrapper relative z-10">
        <div className="text-center">
          {/* Left Content */}
          <div className="lg:col-span-3 space-y-12">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="space-y-8 flex flex-col items-center">
              <div className="space-y-6">
                <InformativeTag>Your Order Awaits</InformativeTag>

                <h2 className="flex flex-wrap justify-center text-3xl md:text-5xl font-bold text-gray-900 leading-tight ">
                  Ready to try{' '}
                  <div className="mx-3 bg-gradient-to-r from-orange-600 to-amber-600 bg-clip-text text-transparent">
                    our food <span className="text-gray-900">?</span>
                  </div>
                </h2>

                {/* <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-amber-500 mx-auto rounded-full mb-6"></div> */}
              </div>

              <div className="space-y-8 pt-8">
                {/* <p className="text-xl lg:text-2xl text-gray-600 font-light leading-relaxed max-w-2xl">
                  Step into a world where every bite connects you to the soul of Haiti. Let us bring these cherished
                  flavors to your table.
                </p> */}

                <div className="flex flex-col items-center gap-8">
                  <motion.div whileHover={{ y: -2 }} transition={{ duration: 0.2 }}>
                    <Link
                      href="/menu"
                      className="group inline-flex items-center gap-3 bg-gradient-to-r from-orange-600 to-orange-500 text-white px-8 py-6 rounded-full text-sm font-medium tracking-wider hover:from-orange-500 hover:to-amber-500 transition-all duration-400 shadow-lg hover:shadow-xl uppercase">
                      Take a look at our menu
                      <motion.div
                        animate={{ x: [0, 5, 0] }}
                        transition={{ duration: 1.5, repeat: Infinity }}
                        className="ml-1">
                        →
                      </motion.div>
                    </Link>
                  </motion.div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

const FloatingBackground = () => (
  <div className="absolute inset-0 overflow-hidden pointer-events-none">
    <motion.div
      whileInView={{ y: [0, -15, 0], rotate: [0, 3, 0] }}
      transition={{ duration: 20, repeat: Infinity, ease: 'linear' }}
      viewport={{ once: false, amount: 0.2 }}
      className="absolute top-20 left-20 w-32 h-32 bg-orange-300/15 rounded-full blur-xl"
    />

    <motion.div
      whileInView={{ y: [0, 20, 0], rotate: [0, -5, 0] }}
      transition={{ duration: 25, repeat: Infinity, ease: 'linear' }}
      viewport={{ once: false, amount: 0.2 }}
      className="absolute bottom-32 right-16 w-48 h-48 bg-amber-300/10 rounded-full blur-2xl"
    />

    <motion.div
      whileInView={{ y: [0, -10, 0], rotate: [0, 2, 0] }}
      transition={{ duration: 15, repeat: Infinity, ease: 'linear' }}
      viewport={{ once: false, amount: 0.2 }}
      className="absolute top-1/2 right-32 w-24 h-24 bg-green-300/20 rounded-full blur-lg"
    />
  </div>
);

export default HomeCTAClient3;
